// import { default as scroll } from "./modules/_scroll"
import { default as desktopHeader } from "./modules/_desktop-header"
import { default as mobileHeader } from "./modules/_mobile-header"
// import { default as dialogs } from "./modules/_dialogs"

(() => {

    mobileHeader.init()
    desktopHeader.init()
    // scroll.init()
    // dialogs.init()
    
})();